
export default function CyberInsuranceHero() {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-[#e10708] via-[#c00607] to-[#a00506] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl mb-8">
          <i className="ri-shield-check-line text-5xl text-white"></i>
        </div>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Cyber Insurance Readiness Checklist
        </h1>
        
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          What healthcare practices need to qualify for cyber insurance coverage—and keep it valid when claims arise
        </p>

        <div className="inline-flex items-center gap-3 bg-white/20 backdrop-blur-sm px-6 py-4 rounded-xl border border-white/30">
          <i className="ri-alert-line text-2xl text-white"></i>
          <p className="text-white font-semibold">
            Answering "no" to key questions could lead to denied claims or coverage gaps
          </p>
        </div>
      </div>
    </section>
  );
}